import React from "react";

import Text from "../../../_components/Text";
import {_Input} from "../../../_components/Input";
import Row from "../../../_components/Layout/Row";
import Card from "../../../_components/Card";
import Column from "../../../_components/Layout/Column";

import data from "./data.jsx"

export default (props) => {
  return (
    <Row>
      <Column col="12 mb-1">
        <Text fontSize="lg" color="primary">
          Novidades no easygestor
        </Text>
      </Column>
      {
        data.map( (item, idx) =>{
          return <Column md="5" lg="4" xs="12" className="mb-3">
          <Card
            img={item.image}
            title={item.title}
            footerButtons={item.buttons}
            footer={item.footer} >
              {item.description}
            </Card>
        </Column>
        })
      }
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/News/index.jsx